<template>
    <section class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Acessórios e equipamentos' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />

        </div>
        <h4 v-if="!resumo" class="mb-2">Selecione os itens existentes no veículo:</h4>
        <div v-if="!resumo" class="flex flex-col justify-between border-[#91CAFF] bg-[#E6F4FF] border rounded-md p-2">
            <span class="font-medium">Legenda</span>
            <div class="flex justify-between flex-wrap mt-1">
                <div class="flex items-center gap-1">
                    <img class="w-8 h-8" src="@/assets/quebrado.png" alt="Imagem automovel tombado"> Quebrado
                </div>
                <div class="flex items-center gap-1">
                    <Icone :nome="'remove'" /> Ausente
                </div>
                <div class="flex items-center gap-1">
                    <Icone :nome="'thumb_up'" /> Bom
                </div>
            </div>
        </div>
        <ItensAcessorio v-if="!resumo" :acessoriosEquipamentos="acessoriosEquipamentos" :etapa="etapaComponente"
            :idComponente="identificador" :modulo="modulo" @aoSelecionarEstado="controlaStatus" />
        <AcessorioResumo v-else :acessoriosEquipamentos="acessoriosEquipamentos" />
    </section>
</template>
<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import ComponenteAcessorioService from '@/services/componentes/ComponenteAcessorioService';
import Icone from '@/components/Icone.vue';
import ItensAcessorio from '@/common/acessoriosEquipamentos/components/ItensAcessorio.vue';
import AcessorioResumo from '@/common/acessoriosEquipamentos/components/AcessorioResumo.vue';
import Status from '@/components/Status.vue';

export default defineComponent({
    name: 'Acessorio',
    components: {
        Icone,
        ItensAcessorio,
        AcessorioResumo,
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        controlaStatus() {
            this.statusResposta = ComponenteAcessorioService.controlarStatus(this.respostaObrigatoria, this.etapaComponente, this.identificador, this.modulo)
        }
    },
    setup(props) {
        return ComponenteAcessorioService.setup(props)
    }
});
</script>